import { ARR_5_MINUTES_INTERVAL, ARR_HOURS_IN_A_DAY } from '@app/booking-libs';
import { Box, ErrorMessage, Inline, Select, xcss } from '@forge/react';
import React from 'react';
const toForgeLabelValue = (value, suffixSingular, suffixPlural) => ({
    label: `${value} ${value === 1 ? suffixSingular : suffixPlural}`,
    value: String(value)
});
export function DurationPicker(props) {
    const hoursOptions = ARR_HOURS_IN_A_DAY.map((h) => toForgeLabelValue(h, 'hour', 'hours'));
    const minutesOptions = ARR_5_MINUTES_INTERVAL.map((m) => toForgeLabelValue(m, 'minute', 'minutes'));
    const daysOptions = [0, 1, 2, 3, 4, 5, 6, 7, 14, 21, 28].map((d) => toForgeLabelValue(d, 'day', 'days'));
    function updateDuration(days, hours, minutes) {
        props.onChange({ days, hours, minutes });
    }
    const { days, minutes, hours } = props.value;
    const invalidDuration = days + minutes + hours === 0;
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, null,
            React.createElement(Inline, { alignBlock: 'baseline', space: 'space.100' },
                React.createElement(Box, { xcss: xcss({ width: '120px' }) },
                    React.createElement(Select, { options: daysOptions, value: toForgeLabelValue(days, 'day', 'days'), onChange: (v) => updateDuration(Number((v === null || v === void 0 ? void 0 : v.value) || 0), hours, minutes) })),
                React.createElement(Select, { options: hoursOptions, value: toForgeLabelValue(hours, 'hour', 'hours'), onChange: (v) => updateDuration(days, Number((v === null || v === void 0 ? void 0 : v.value) || 0), minutes) }),
                React.createElement(Select, { options: minutesOptions, value: toForgeLabelValue(minutes, 'minute', 'minutes'), onChange: (v) => updateDuration(days, hours, Number((v === null || v === void 0 ? void 0 : v.value) || 0)) })),
            invalidDuration && React.createElement(ErrorMessage, null, "Invalid duration."))));
}
